import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { getSlot as B } from "../../shared/v-node.js";
import { getScrollParent as L } from "./utils.js";
import { defineComponent as R, provide as y, getCurrentInstance as T, inject as b, onBeforeUnmount as V } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { off as l, on as d } from "../../../../../../evtd@0.2.4/node_modules/evtd/es/delegate.js";
import { beforeNextFrameOnce as x } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/animation/next-frame-once.js";
import { ref as P } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const C = R({
  name: "Binder",
  props: {
    syncTargetWithParent: Boolean,
    syncTarget: {
      type: Boolean,
      default: !0
    }
  },
  setup(m) {
    var n;
    y("VBinder", (n = T()) === null || n === void 0 ? void 0 : n.proxy);
    const c = b("VBinder", null), s = P(null), u = (e) => {
      s.value = e, c && m.syncTargetWithParent && c.setTargetRef(e);
    };
    let t = [];
    const p = () => {
      let e = s.value;
      for (; e = L(e), e !== null; )
        t.push(e);
      for (const v of t)
        d("scroll", v, a, !0);
    }, f = () => {
      for (const e of t)
        l("scroll", e, a, !0);
      t = [];
    }, o = /* @__PURE__ */ new Set(), h = (e) => {
      o.size === 0 && p(), o.has(e) || o.add(e);
    }, w = (e) => {
      o.has(e) && o.delete(e), o.size === 0 && f();
    }, a = () => {
      x(z);
    }, z = () => {
      o.forEach((e) => e());
    }, r = /* @__PURE__ */ new Set(), S = (e) => {
      r.size === 0 && d("resize", window, i), r.has(e) || r.add(e);
    }, g = (e) => {
      r.has(e) && r.delete(e), r.size === 0 && l("resize", window, i);
    }, i = () => {
      r.forEach((e) => e());
    };
    return V(() => {
      l("resize", window, i), f();
    }), {
      targetRef: s,
      setTargetRef: u,
      addScrollListener: h,
      removeScrollListener: w,
      addResizeListener: S,
      removeResizeListener: g
    };
  },
  render() {
    return B("binder", this.$slots);
  }
}), O = C;
export {
  O as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vueuc@0.4.64_vue@3.5.18/~/vueuc/es/binder/src/Binder.js
// module id = 170
// module chunks = 41